<style lang="stylus">
    .rightMenuOption-modal
        width 483px

        .rightMenuOption-content
            display flex
            flex-wrap wrap

            .rightMenuOption-item
                display flex
                align-items center
                width 128px
                height 36px
                background var(--bg-color-right-menu-option-item)
                border-radius 6px
                margin-right 24px
                margin-bottom 24px
                padding 0 10px
                cursor pointer
                &:hover{
                  background $main-selectcolorb
                }

                &:nth-child(3n)
                    margin-right 0

                .item-icon
                    width 32px
                    height 32px
                    color: var(--svg-color-primary-secondary)

                .check-icon
                    width 16px
                    height 16px
                    stroke none
                    fill none
                    margin-left auto
                    &.unchecked
                        color var(--svg-color-right-menu-option-modal-unchecked)
                    &.checked
                        color var(--themeColor)

                .text
                    width 50px
                    margin 0 4px
                    font-size 12px
                    color var(--text-color-primary)
                    line-height 16px
                    overflow hidden
                    text-overflow ellipsis
                    white-space nowrap

            .rightMenuOption-footer
                height 28px
                padding-right 0
                div
                    height 28px
                    padding 0 24px
                    line-height 28px
                    border-radius 6px
</style>

<template>
    <Dialog class="rightMenuOption-modal" :title="$t('title')" :mask="true" @close="closeModal">
        <div class="rightMenuOption-content">
            <div class="rightMenuOption-item" :class="{ active: !tempList.includes(key) }" @click="toggle(key)" v-for="(item, key, index) in pics">
                <iconSymbol class="item-icon" :name="`rightmenu-${item.icon}`"></iconSymbol>
                <p class="text" :title="$t(item.tips)">{{ $t(item.tips) }}</p>
                <iconSymbol
                    class="item-icon check-icon"
                    :class="!tempList.includes(key) ? 'checked' : 'unchecked'"
                    :name="`rightmenu-${!tempList.includes(key) ? 'checked' : 'unchecked'}`"
                ></iconSymbol>
            </div>
            <div class="dialog-btnbox-normal rightMenuOption-footer">
                <div class="dialog-btn-ok" @click="confirm" :style="{ marginRight: internal ? '0' : '5px' }">{{ $t("confirm") }}</div>
                <div class="" @click="cancel" :style="{ marginRight: !internal ? '0' : '5px' }">{{ $t("cancel") }}</div>
            </div>
        </div>
    </Dialog>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Inject } from "vue-property-decorator";
    import Dialog from "./Dialog.vue";

    @Component({
        components: {
            Dialog,
        },
    })
    export default class RightMenuOption extends Vue {
        @Inject()
        ["showMessage"];
        pics = {
            shapeP: {
                name: "rightmenu1",
                tips: "style",
                icon: "style",
            },
            pageset: {
                name: "rightmenu11",
                tips: "pageset",
                icon: "page",
            },
            themeP: {
                name: "rightmenu3",
                tips: "theme",
                icon: "theme",
            },
            // layerP:{
            //     name: 'rightmenu4',
            //     tips: 'layer',
            // },
            slideset: {
                name: "rightmenu15",
                tips: "slideset",
                icon: "ppt",
            },
            propertyP: {
                name: "rightmenu5",
                tips: "attr",
                icon: "data",
            },
            // imageset:{
            //     name: 'rightmenu2',
            //     tips: 'image',
            // },
            // orgchart:{
            //     name: 'rightmenu7',
            //     tips: 'orgchart',
            // },
            // planset:{
            //     name: 'rightmenu12',
            //     tips: 'planset',
            // },
            // gantt:{
            //     name: 'rightmenu6',
            //     tips: 'gantt',
            // },
            // mindmaster:{
            //     name: 'rightmenu14',
            //     tips: 'mindmaster',
            // },
            revisions: {
                name: "rightmenu13",
                tips: "revisions",
                icon: "reversion",
            },
            // layout:{
            //     name: 'rightmenu10',
            //     tips: 'smartShape',
            // },
            // tableset:{
            //     name: 'rightmenu8',
            //     tips: 'table',
            // },
            // echart:{
            //     name: 'rightmenu9',
            //     tips: 'echart',
            // },
        };
        tempList = ["echart"];

        get hiddenRightViewList() {
            return this.$store.state.ui.hiddenRightViewList;
        }
        set hiddenRightViewList(v) {
            this.$store.commit("setStatus", {
                type: "hiddenRightViewList",
                data: v,
            });
        }

        toggle(key) {
            let index = this.tempList.indexOf(key);
            (index == -1 && this.tempList.push(key)) || this.tempList.splice(index, 1);
            console.log(this.tempList);
        }

        confirm() {
            localStorage.setItem("rightViewList", JSON.stringify(this.tempList));
            this.hiddenRightViewList = this.tempList;
            this.closeModal();
        }

        cancel() {
            this.closeModal();
        }

        closeModal() {
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });
        }

        mounted() {
            this.tempList = JSON.parse(JSON.stringify(this.hiddenRightViewList));
        }
        get editTeamOption() {
            return this.$store.state.ui.editTeamOption;
        }

        created() {
            if (this.isPlugin) {
                delete this.pics.slideset;
                delete this.pics.propertyP;
                delete this.pics.revisions;
            }
            if (this.editTeamOption) {
                delete this.pics.revisions;
            }
        }
    }
</script>
<i18n>
{
  "zh": {
    "title": "管理右侧面板图标",
    "style": "样式",
    "image": "图片",
    "theme": "主题",
    "layer": "图层",
    "attr": "形状数据",
    "gantt": "甘特图",
    "orgchart": "组织结构图",
    "table": "表格",
    "echart": "图表",
    "smartShape": "图形",
    "timeline": "时间线",
    "pageset": "页面设置",
    "planset": "平面图",
    "revisions": "历史版本",
    "mindmaster": "思维导图",
    "slideset": "文档演示",
    "confirm": "确定",
    "cancel": "取消"
  },
  "en": {
    "title": "Manage task pane",
    "style": "Style",
    "image": "Image",
    "theme": "Theme",
    "layer": "Layer",
    "attr": "Data Property",
    "gantt": "Gantt Chart",
    "orgchart": "Org Chart",
    "table": "Table",
    "echart": "Chart",
    "smartShape": "Smart Shape",
    "timeline": "Timeline",
    "pageset": "Page Settings",
    "planset": "Floor Plan",
    "revisions": "Historical Version",
    "mindmaster": "MindMap",
    "slideset": "Slide",
    "confirm": "OK",
    "cancel": "Cancel"
  },
  "fr": {
    "title": " Gérer la barre d'outils droite.",
    "style": "Style",
    "image": "Image",
    "theme": "Thème",
    "layer": "Couche",
    "attr": "Propriété de données",
    "gantt": "Diagramme de Gantt",
    "orgchart": "Organigramme",
    "table": "Table",
    "echart": "Graphique",
    "smartShape": "Graphique",
    "timeline": "chronologie",
    "pageset": "Paramètres de Page",
    "planset": "Plan d'étage",
    "revisions": "Version Historique",
    "mindmaster": "Carte Mentale",
    "slideset": "Présentation du document",
    "confirm": "Confirmer",
    "cancel": "Annuler"
  },
  "de": {
    "title": "Rechte Systemleiste verwalten",
    "style": "Format",
    "image": "Bild",
    "theme": "Thema",
    "layer": "Ebene",
    "attr": "Dateneigenschaft",
    "gantt": "Gannt-Diagramm",
    "orgchart": "Organigramm",
    "table": "Tabelle",
    "echart": "Diagramm",
    "smartShape": "Grafik",
    "timeline": "Zeitleiste",
    "pageset": "Seiteneinstellung",
    "planset": "Grundriss",
    "revisions": "Historische Version",
    "mindmaster": "Mind Map",
    "slideset": "Diashow",
    "cancel": "Abbrechen",
    "tip": "Hinweis"
  },
  "jp": {
    "title": "右ツールバーの管理",
    "style": "スタイル",
    "image": "画像",
    "theme": "テーマ",
    "layer": "レイヤ",
    "attr": "属性",
    "gantt": "ガントチャート",
    "orgchart": "組織図",
    "table": "フォーム",
    "echart": "チャート",
    "smartShape": "図形",
    "timeline": "タイムライン",
    "pageset": "ページ設定",
    "planset": "間取り図",
    "revisions": "前のバージョン",
    "mindmaster": "マインドマップ",
    "slideset": "プレゼンテーション",
    "cancel": "キャンセル",
    "tip": "ご注意"
  },
  "es": {
    "title": "Administrar la barra de herramientas de la derecha",
    "style": "Estilo",
    "image": "Imagen",
    "theme": "Tema",
    "layer": "Capa",
    "attr": "Propiedad de los datos",
    "gantt": "Gráfico de Gantt",
    "orgchart": "Organigráma",
    "table": "Mesa",
    "echart": "Gráfico",
    "smartShape": "Forma inteligente",
    "timeline": "cronología",
    "pageset": "Configuración de la página",
    "planset": "Plano de la planta",
    "revisions": "Versión histórica",
    "mindmaster": "Mapa mental",
    "slideset": "Diapositiva",
    "confirm": "OK",
    "cancel": "Cancelar"
  },
  "pt": {
    "title": " Gerenciar a barra de ferramentas certa",
    "style": "Estilo",
    "image": "Imagem",
    "theme": "Tema",
    "layer": "Camada",
    "attr": "Propriedade de Dados",
    "gantt": "Gráfico de Gantt",
    "orgchart": "Organograma",
    "table": "Tabela",
    "echart": "Gráfico",
    "smartShape": "Forma Inteligente",
    "timeline": "Linha do tempo",
    "pageset": "Configurações de Página",
    "planset": "Planta",
    "revisions": "Versão Histórica",
    "mindmaster": "MindMaster",
    "slideset": "Slide",
    "confirm": "OK",
    "cancel": "Cancelar"
  },
  "it": {
    "title": " Gestisci la barra degli strumenti a destra",
    "style": "Stile",
    "image": "Immagine",
    "theme": "Tema",
    "layer": "Livello",
    "attr": "Proprietà Dati",
    "gantt": "Diagramma di Gantt",
    "orgchart": "Organigramma",
    "table": "Tabella",
    "echart": "Diagramma",
    "smartShape": "Smart Shape",
    "pageset": "Impostazioni Pagina",
    "planset": "Planimetria",
    "revisions": "Cronologia Versioni",
    "mindmaster": "Mappatura Mentale",
    "slideset": "Diapositiva",
    "confirm": "OK",
    "cancel": "Annulla"
  },
  "tw": {
    "title": "管理右側工具欄",
    "style": "樣式",
    "image": "圖片",
    "theme": "主題",
    "layer": "圖層",
    "attr": "形狀數據",
    "gantt": "甘特圖",
    "orgchart": "組織結構圖",
    "table": "表格",
    "echart": "圖表",
    "smartShape": "圖形",
    "timeline": "時間線",
    "pageset": "頁面設置",
    "planset": "平面圖",
    "revisions": "歷史版本",
    "mindmaster": "心智圖",
    "slideset": "檔案演示",
    "confirm": "確定",
    "cancel": "取消"
  },
  "kr": {
    "title": "오른쪽 판넬 아이콘 관리",
    "style": "스타일",
    "image": "이미지",
    "theme": "주제",
    "layer": "도층",
    "attr": "형상 데이터",
    "gantt": "간트 차트",
    "orgchart": "조직 차트",
    "table": "표",
    "echart": "차트",
    "smartShape": "도형",
    "timeline": "타임라인",
    "pageset": "페이지 설정",
    "planset": "평면도",
    "revisions": "기록 버전",
    "mindmaster": "마인드맵",
    "slideset": "슬라이드",
    "confirm": "확인",
    "cancel": "취소"
  }
}
</i18n>
